module.exports = __webpack_public_path__ + "82c6b44b4fb9879984182a69a6d63e74.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BT.svg
// module id = MWjD
// module chunks = 0